import axios from 'axios';
import router from '../router/router.js';

const secureAxios = axios.create({
  // Remove baseURL to avoid adding /api automatically
  timeout: 10000, // Optional: Keep timeout for reliability
});

// Automatically attach token to every request
secureAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for handling 401/403 errors
secureAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.error('Authentication error:', error.response.data.message);
      localStorage.removeItem('authToken'); // Clear the invalid token
      router.push('/login'); // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default secureAxios;